module.exports = __webpack_public_path__ + "img/SKMJ_rest3.36ecefd8.jpg";